module.exports = __webpack_public_path__ + "media/la_mun_kra_tug.1648b293.mp3";